import { IconName } from '../IconSvg'

export const TOOLTIP_DELAY_SHOW = 500
export const SELECT_ALL = 'SELECT_ALL'
export const DESELECT_ALL = 'DESELECT_ALL'
export const NOT_SET_DISPLAY_VALUE = '\u2013' // html dash
// double check these icons!
export const ICON_STATE: IconName[] = ['sortDown', 'sortDown', 'sortUp']
